
import { Box, HStack } from '@chakra-ui/react';
import { ChevronUp, User } from 'lucide-react';

import { selectCommentPanelIsOpen, setCommentPanelIsOpen, useAppDispatch, useAppSelector } from '@state';

import { RtaIconButton } from '@components';

// Add comment adds a comment to a component
// Open comment panel opens a list of all comments and also allows for general comments
export const CommentControls = () => {
	const dispatch = useAppDispatch();
	const commentPanelIsOpen = useAppSelector(selectCommentPanelIsOpen);

	return (
		<Box w={'100%'} h={'100%'} m={'1px'} border={'0px'}>
			<HStack h={'100%'} gap={0}>
				<RtaIconButton enabled={true} icon={<User/>} label="Add Comment"/>

				<RtaIconButton
					enabled={true}
					icon={<ChevronUp/>}
					label={`${commentPanelIsOpen ? 'Hide' : 'Open'} Comment Panel`}
					onClick={() => dispatch(setCommentPanelIsOpen(!commentPanelIsOpen))}

				/>

				{/* <RtaIconButton
							enabled={ customerDesigns && customerDesigns.designs.length > 0 && contentPanelMode !== ContentPanelMode.findCustomer }
							icon={<FileText/>}
							label={`${estimatePanelIsOpen ? 'Hide' : 'Open'} Estimate`}
							onClick={() => dispatch(setEstimatePanelIsOpen(!estimatePanelIsOpen))}
						/> */}

				{/* <Divider orientation="vertical" h={'100%'} /> */}
			</HStack>
		</Box>
	);
};
